import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import StrategyDetailStore from './store';
import Page from '../../components/page';
import DateUtil from '@src/utils/date-util';
import PageLayout from '@src/business-components/page-layout';
import ArticleBtn from '@src/business-components/article-btn';
import EmptyText from '@src/business-components/empty-text';
import { convertPxToRem } from '@src/utils/common-util';
const styles = require('../news-detail/index.less');

const StrategyDetail = () => {
  const store = useStore(() => new StrategyDetailStore());
  return (
    <Page className={styles.newsDetailRoot}>
      <PageLayout store={store.pageLayoutStore}>
        <div className={styles.content}>
          {store.currentArticle ? (
            <div className="news-detail-group-6" data-name="内容">
              <div className="news-detail-layer-13" data-name="《剑侠世界4》8月13日更新预告">
                {store.currentArticle.title}
              </div>
              <div className="news-detail-layer-12" data-name="2025/08/12 16:49:39">
                {/* 作者：{store.currentArticle.authorName || '-'} */}
                {DateUtil.formatDate(new Date(store.currentArticle.publishedAt * 1000), 'yyyy/MM/dd hh:mm:ss')}
              </div>
              <div className="news-detail-layer-11" />
              <div
                className="news-detail-layer-10"
                data-name="《剑侠世界3》手游全服预计将于8月13日06:00进行停服更新，预计维护2小时。具体的维护内容和开服时间，根据实际情况而定，如"
                dangerouslySetInnerHTML={{ __html: convertPxToRem(store.currentArticle.content) }}
              />
            </div>
          ) : (
            <div className="news-detail-group-6" data-name="内容">
              <EmptyText className="news-detail-empty" />
            </div>
          )}

          <div className="news-detail-group-7" data-name="上下篇">
            <ArticleBtn store={store.articleBtnStore} />
          </div>
        </div>
      </PageLayout>
    </Page>
  );
};

export default observer(StrategyDetail);
